import type { Avfall, AvfallType } from '../../services/rtkApi';
import { isSortedType } from './utils';

/**
 * Handle change to an avfall field
 */
export const updateAvfallField = (
    avfallList: Array<Avfall>,
    index: number,
    field: 'avfallTypeId' | 'mengde',
    value: number | null,
    avfallTypes: Array<AvfallType> | undefined,
): Array<Avfall> => {
    return avfallList.map((avfall, idx) => {
        if (idx !== index) return avfall;

        if (field === 'avfallTypeId') {
            const selectedType = avfallTypes?.find(
                (t) => t.avfallTypeId === value,
            );
            return {
                ...avfall,
                avfallTypeId: selectedType?.avfallTypeId ?? null,
                avfallType: selectedType?.beskrivelse ?? '',
                sortert: isSortedType(selectedType),
            };
        }

        // For mengde field, ensure it's a valid number
        return {
            ...avfall,
            mengde: typeof value === 'number' ? value : 0,
        };
    });
};

/**
 * Delete an avfall row by index
 */
export const deleteAvfallRow = (
    avfallList: Array<Avfall>,
    index: number,
): Array<Avfall> => {
    return avfallList.filter((_, idx) => idx !== index);
};
